import { render } from "./warranty_claim_approval.vue?vue&type=template&id=669c4b7a&scoped=true"
import script from "./warranty_claim_approval.vue?vue&type=script&lang=js"
export * from "./warranty_claim_approval.vue?vue&type=script&lang=js"

import "./warranty_claim_approval.vue?vue&type=style&index=0&id=669c4b7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669c4b7a"]])

export default __exports__